import React from 'react';
import { Text, View } from "../../../Components/Themed";
import { useColors } from "../../../constants/useColors";
import type { GroupMessageProps, MyPlayerProps, OrderProps, PublicPlayerProps, TextTagProps } from "../../../types";
import { FormattedText } from '../../FormattedTextInput/FormattedText';
import moment from 'moment-mini';
import { Image } from 'react-native';
import ImageRenderer from '../../ImageRenderer';
import UrlPreviewCard from '../../UrlPreviewCard';
import SocialOrdersList from '../../SocialOrdersList';


type GroupMessageCardProps = {
    group_message:GroupMessageProps,
    me?:MyPlayerProps,
    orders:OrderProps[],
    player?:PublicPlayerProps,
    mine?:boolean,
    onCopyOrder?:(order:OrderProps) => void,
    onFadeOrder?:(order:OrderProps) => void,
    width: number,
    onSelectImage:(image:{ url:string, height?:number, width?:number }) => void,
    onSelectTag:(tag:TextTagProps) => void
}

const GroupMessageCard = ({group_message, orders, mine, player, width, onSelectImage, onSelectTag, onCopyOrder, onFadeOrder}:GroupMessageCardProps) => {
    const Colors = useColors();
    const image = group_message.message_images ? group_message.message_images[0] : undefined
    const url = group_message.message_urls ? group_message.message_urls[0] : undefined

    return (
        <View>
            <View style={{ flexDirection:'row', alignItems:'flex-end' }}>
                {mine ?
                <View style={{ flex:1 }} transparent />
                :
                <View float style={{ borderRadius:100, padding:2 }}>
                    <Image
                        source={{ uri:player?.profile_pic }}
                        style={{ height:36, width:36, borderRadius:100 }}
                        resizeMode='cover'
                    />
                </View>
                }
                <View float style={{ 
                    width: mine ? width - 45 : width - 90, 
                    padding:14,
                    marginLeft:10,
                    borderRadius:22,
                    marginBottom:15,
                    borderBottomLeftRadius: !mine? 0:22,
                    borderBottomRightRadius: mine? 0:22, 
                    backgroundColor:mine?Colors.absolutes.brand.midnight:Colors.absolutes.highlights.highlight200 
                }}>
                    {group_message.formatted_text ?
                    <FormattedText
                        text={group_message.formatted_text}
                        tags={group_message.tags ?? []}
                        text_color={Colors.text.white}
                        onSelectTag={(tag) => onSelectTag(tag)}
                    />
                    : group_message.message ?
                    <Text size={12} color={Colors.text.white}>{group_message.message}</Text>
                    :<></>}
                    {url ?
                    <View transparent style={{ marginTop:10 }}>
                        <UrlPreviewCard
                            url={url}
                            max_height={120}
                            width={width - 120}
                            color={Colors.text.white}
                        />
                    </View>
                    :<></>}
                    {image ?
                    <ImageRenderer
                        image={image}
                        width={width - 120}
                        onSelectImage={onSelectImage}
                    />
                    :<></>}
                    {player && orders && orders.length > 0 ?
                    <View float style={{ padding:4, marginTop:10 }}>
                        <SocialOrdersList
                            orders={orders}
                            onCopyOrder={onCopyOrder}
                            onFadeOrder={onFadeOrder}
                            maxWidth={width - 120}
                            players={[player]}
                            direction='horizontal'

                        />
                    </View>
                    :<></>}
                </View>
                {!mine ?
                <View transparent />
                :<></>}
            </View>
            <Text theme="light" textAlign={mine?'right':'left'}>{!mine && player ?`@${player?.username} - `: ''}Delivered {moment(group_message.create_datetime).format('hh:mm a')}</Text>
        </View>
    )
}

export default GroupMessageCard